import { baseURL } from "../../utils/misc";


 export const getAllCrops = async () => {
  const requestOptions = {
    method: "GET",
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/crops`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching all Crops!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
